import type { GridColDef } from "@mui/x-data-grid-premium";
import { Typography } from "@mui/material";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";
import type { ProductColumns__ItemFragment } from "./productColumns.generated.js";

interface Options {
  headerName: string;
}

export function createProductGtinColumn<
  T extends DocDataGrid_ItemFragment & ProductColumns__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "productGtin",
    headerName: options.headerName,
    width: 100,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.type !== "paid" || item.isItemEliminated) return null;
      if (!item.product) return null;
      const gtin = item.product.gtin;
      if (!gtin) return null;
      return (
        <Typography variant="body2" noWrap>
          {gtin}
        </Typography>
      );
    },
  };
}
